import $api from "@api/api";


function ReportHelper(reportConfiguration) {
  this.reportConfiguration = reportConfiguration;
	this.localPartnerId = this.reportConfiguration.partnerId;
}

ReportHelper.prototype.init = async function () {
	if(!this.localPartnerId && this.reportConfiguration.venueId) {
  	const venue = (await $api.venues.getVenue(this.reportConfiguration.venueId, {'withPartner': true})).data;
	this.reportConfiguration.partner = venue.partner;
  }
	if (this.localPartnerId) {
		this.reportConfiguration.partner = (await $api.partners.getCurrentPartner(this.localPartnerId)).data;
    if (this.reportConfiguration.getPermissions) {
      this.reportConfiguration.permissions = (await $api.reports.runReport(this.reportConfiguration.report.id, {
        ...this.reportConfiguration.getPermissions,
				partnerId: this.localPartnerId
      })).data;
    }
		this.reportConfiguration.$set(this.reportConfiguration.filters, 'partnerId', this.localPartnerId)
    delete this.reportConfiguration.displayFilters.partner;
  }

  await this.getConstants();
  this.initFilters();
  this.reportConfiguration.$emit('filters', this.reportConfiguration.filters);

  this.echoReportExportEvent();

}

ReportHelper.prototype.getConstants = async function () {
  this.reportConfiguration.constants = (await $api.reports.getConstants()).data;
}

ReportHelper.prototype.initFilters = async function (keys = null) {
  if(this.reportConfiguration.filterPresets) {
    this.reportConfiguration.filters = {...this.reportConfiguration.filters, ...this.reportConfiguration.filterPresets};
  }
  
	if(this.reportConfiguration.displayFilters) {
		const displayFilters = this.reportConfiguration.displayFilters;
		const local = Promise.all(Object.keys(displayFilters).filter(key => !keys || keys.includes(key)).map(key =>
			ReportHelper.filterFunctions[key]?.load.apply(this, [displayFilters[key].filterParams])
		));
		return local.then(() => this.filterEmitters()); 
	}
}

ReportHelper.prototype.getData = async function () {
  const subreportsToRun = [];
  if (this.reportConfiguration.fireGetData && this.hasRequiredFilters()) {
    for (const subreport of Object.values(this.reportConfiguration.subreports)) {
      subreportsToRun.push(subreport);
    }

    if (subreportsToRun.length > 0 && this.reportConfiguration.fireGetData) {
      this.reportConfiguration.getDataExecuted = true;
      this.reportConfiguration.fireGetData = false;
      delete this.reportConfiguration.filters.report;
      if (this.reportConfiguration.filters.partnerId &&
	    (!this.reportConfiguration.partner || this.reportConfiguration.partner.id !== this.reportConfiguration.filters.partnerId)) {
				this.localPartnerId = this.reportConfiguration.filters.partnerId;
				this.reportConfiguration.partner = (await $api.partners.getCurrentPartner(this.localPartnerId)).data;
      }
      if(this.reportConfiguration.runSequentially) {
          for(let i = 0; i < subreportsToRun.length; i++) {
              await (this.runSubreport(subreportsToRun[i], false).catch());
          }
      } else {
          return Promise.all(subreportsToRun.map(s => this.runSubreport(s, false)));
      }
    }
  }

  return Promise.resolve();
}

ReportHelper.prototype.getParams = function (filters, params) {
	const effectiveFilters = Object.keys(filters).filter(key => !params.except?.includes(key)).reduce((obj, key) => {
		obj[key] = filters[key];
		return obj;
	}, {});
	return {...effectiveFilters, ...params}
}

ReportHelper.prototype.runSubreport = async function (subreport, response, forceLoading = false) {  
  subreport.loading = true;
	
  if (subreport.summation) subreport.summation.value = 0;

  const params = this.getParams(this.reportConfiguration.filters, subreport.tableData.params);
  if (response) {
    params.page = Number(response.page);
    params.display = Number(response.itemsPerPage);
      if(subreport?.tableData?.response?.data) {
        const totalRow = subreport.tableData.response.data.find(x => x.totalRow);
        params['paginator_count'] = subreport.tableData.response.total;
        params['paginator_totals'] = totalRow ?? [];
      }
  }
  
  let reportResponse = emptyResultSet;
  if(forceLoading || !subreport.preventLoading) {
    if (subreport.tableData)
      subreport.tableData.error = false;

    try {
      if (this.reportConfiguration.report.kind === 'venue') {
        reportResponse = (await $api.reports.runVenueReport(this.reportConfiguration.report.id, this.reportConfiguration.venueId, params)).data;
      } else {
        reportResponse = (await $api.reports.runReport(this.reportConfiguration.report.id, params)).data;
      }
    } catch(e) {
      if (subreport.tableData)
        subreport.tableData.error = e.message;
    }
  }

  if (subreport.tableData.preProcess) {
    subreport.tableData.preProcess(reportResponse, this.reportConfiguration);
  }

  if (subreport.tableData.totalizer) {
    let total = reportResponse.data.find(x => x[subreport.tableData.totalizer.fieldName] === 'Total');
    if (!total) total = subreport.tableData.totalizer.onEmpty;
    Object.entries(subreport.tableData.totalizer.constant ?? {}).forEach(([key, value]) => total[key] = value);
    total.totalRow = true;
    if (subreport.summation) {
      subreport.summation.value = total[subreport.tableData.totalizer.totalFieldName];
    }
    
    (subreport.tableData.totalizer.removeOnZero ?? []).forEach(field => {
      if (!Math.abs(total[field]) > 0) {
        delete subreport.tableData.columnOptions[field];
      }
    })
  }

  if (subreport.summations) {
    Object.keys(subreport.summations).forEach(key => {
      subreport.summations[key] = {...subreport.summations[key], ...reportResponse.summations[key]};
    });
  }

  if (subreport.chartData) {
    subreport.chartData.render(reportResponse, this.reportConfiguration);
  }
  if (subreport.display) {
    subreport.display.value = reportResponse[subreport.display.field];
  }
  subreport.tableData.response = reportResponse;
  subreport.loading = false;
}

const emptyResultSet = {
  "current_page": 1,
  "data": [ ],
  "first_page_url": "",
  "from": 1,
  "last_page": 1,
  "last_page_url": "",
  "links": [{
    "url": null,
    "label": "&laquo; Previous",
    "active": false
  }, {
    "url": "",
    "label": "1",
    "active": true
  }, {"url": null, "label": "Next &raquo;", "active": false}],
  "next_page_url": null,
  "path": "",
  "per_page": 20,
  "prev_page_url": null,
  "to": 1,
  "total": 0
}

ReportHelper.prototype.checkRequiredFilters = function (requiredFilters, filters) {
	return !requiredFilters || requiredFilters
		.every(f => !!filters[f] &&
			(Array.isArray(filters[f]) ? filters[f].length > 0 : true));
}

ReportHelper.prototype.hasRequiredFilters = function () {
	return this.checkRequiredFilters(this.reportConfiguration.requiredFilters, this.reportConfiguration.filters);
}

ReportHelper.prototype.exportSubreport = async function (subreport) {
  subreport.exportData.loading = true;

  if (this.reportConfiguration.constants.waitTimeUntilMail) {
    subreport.exportTimeout = setTimeout(() => {
      subreport.exportData.loading = false;
      const results = subreport.exportData.results;
      if (results) {
        results.publicTrackingId = null;
        if (results.exportId) {
          $api.reports.setExportByMail(results.exportId);
        }
      }
      Bandwango.helpers('notify', {align: 'center', type: 'info', icon: 'fa fa-info mr-1', message: 'The report will be sent to your email shortly.', timer: 10000});
    }, this.reportConfiguration.constants.waitTimeUntilMail);
  }

  const filterDescriptions = Object.keys(this.reportConfiguration.displayFilters).map(key => {
    const text = ReportHelper.filterFunctions[key]?.getText.apply(this, [this.reportConfiguration.filters, this.reportConfiguration.displayFiltersData[key]])
    return text ? {title: this.reportConfiguration.displayFilters[key].name, text: text} : null;
  }).filter(f => f);

  const params = {...this.reportConfiguration.filters, ...subreport.tableData.params, title: subreport.tableData.label, filterDescriptions: JSON.stringify(filterDescriptions)};

  const reportId = params.reportName ? params.reportName : this.reportConfiguration.report.id;

  if (this.reportConfiguration.report.kind === 'venue') {
    subreport.exportData.results = (await $api.reports.exportVenueReport(reportId, this.reportConfiguration.venueId, params)).data;
  } else {
    subreport.exportData.results = (await $api.reports.exportReport(reportId, params)).data;
  }
}

ReportHelper.prototype.echoReportExportEvent = function () {
  Echo.channel('report-export-event').listen('ReportExported', async (ev) => {
    for (const subreport of Object.values(this.reportConfiguration.subreports)) {
      if (ev.trackingId && subreport.exportData?.results?.publicTrackingId === ev.trackingId) {

        if (subreport.exportTimeout) {
          clearTimeout(subreport.exportTimeout);
        }

        switch (ev.results.status) {
          case 'exported': {
            const reportUrl = ev.reportUrl.replaceAll('{trackingId}', subreport.exportData.results.privateTrackingId);
            const fileName = reportUrl.split('/').pop();
            let blobUrl;

            try {
              const response = await fetch(reportUrl);
              const blob = await response.blob();
              const csvLink = document.createElement('a');
              blobUrl = URL.createObjectURL(blob);
              csvLink.href = blobUrl;
              csvLink.setAttribute('download', fileName);
              document.body.appendChild(csvLink);
              csvLink.click();
              document.body.removeChild(csvLink);
            } catch (error) {
              console.error('Error downloading the file:', error);
            } finally {
              Bandwango.helpers("notify", {
                align: "center",
                type: "info",
                icon: "fa fa-info mr-1",
                message: `Click <a href="${blobUrl || reportUrl}" download="${fileName}" target="_blank">
                            HERE</a> if the file did not auto download.`,
                timer: 10000
              });
            }

            break;
          }
          case 'mailed': {
	          Bandwango.helpers('notify', {
              align: 'center',
              type: 'info',
              icon: 'fa fa-info mr-1',
              message: 'The report was sent to your mail.',
              timer: 10000
            });
            break;
          }
          case 'error': {
            Bandwango.helpers("notify", {
              align: "center",
              type: 'danger',
              icon: 'fa fa-exclamation mr-1',
              message: ev.results.msg ? ev.results.msg : 'An error occurred while exporting the report.',
              timer: 10000
            });
            break;
          }
        }
        subreport.exportData.loading = false;
      }
    }
  });
}

ReportHelper.prototype.rowClicked = function (subreport, event) {
  if (subreport.dependants) {
    for (const dependant of subreport.dependants) {
	    if(!subreport.tableData?.multiple) {
		    const depSubReport = this.reportConfiguration.subreports[dependant.subreport];
		    const params = depSubReport.tableData.params;
		    for (const [key, value] of Object.entries(dependant.eventParams)) {
			    params[key] = Array.isArray(params[key]) ? [event[value]] : event[value];
		    }
		    this.runSubreport(depSubReport, false, true);
	    }
    }
  }
}

ReportHelper.prototype.rowSelected = function (subreport, ids) {
	if (subreport.dependants) {
		for (const dependant of subreport.dependants) {
			if(subreport.tableData?.multiple) {
				const depSubReport = this.reportConfiguration.subreports[dependant.subreport];
				const params = depSubReport.tableData.params;
				if(dependant.selectionFieldName) {
					if(ids && ids.length > 0) {
						params[dependant.selectionFieldName] = ids;	
					} else {
						params[dependant.selectionFieldName] = dependant.emptySelectionValue ?? [];	;
					}
				}
				this.runSubreport(depSubReport, false, true);
			}
		}
	}
}

ReportHelper.prototype.watchSuccessMessage = function (msg) {
  if (msg) {
    Bandwango.helpers('notify', {align: 'center', type: 'success', icon: 'fa fa-check mr-1', message: msg});
    this.reportConfiguration.success_msg = '';
  }
}

ReportHelper.prototype.watchErrorMessage = function (msg) {
  if (msg) {
    Bandwango.helpers('notify', {align: 'center', type: 'danger', icon: 'fa fa-exclamation mr-1', message: msg});
    this.reportConfiguration.error_msg = '';
  }
}

ReportHelper.prototype.watchParentFilterHandler = async function (val) {
  if(this.initialLoad) return;
  let updateSelects = false;
  if (val.partnerId && val.partnerId !== this.reportConfiguration.filters.partnerId) updateSelects = true;
  this.reportConfiguration.filters = {...this.reportConfiguration.filters, ...val};
  if (updateSelects) {
    this.initFilters();
  }
  this.getData().then(() => {
    this.reportConfiguration.fireGetData = true
  });
}



ReportHelper.prototype.updateNestedFilters = async function (val) {
	if(this.initialLoad) return;
	const keysWithDependsOn = Object.keys(this.reportConfiguration.displayFilters).filter((key) => {
		const filter = this.reportConfiguration.displayFilters[key];
		if (filter.dependsOn) {
			return filter.dependsOn.every((depKey) => {
				const filterValue = val[depKey];
				return filterValue !== undefined && filterValue !== null && (!Array.isArray(filterValue) || filterValue.length > 0);
			});
		}
		return false;
	});
	if (keysWithDependsOn.length) {
		this.reportConfiguration.filters = {...this.reportConfiguration.filters, ...val};
		this.initialLoad = true;
		this.initFilters(keysWithDependsOn).then(() => {
			this.initialLoad = false;
		});
	}
}

ReportHelper.prototype.filterEmitters = function () {
  const localDisplayFilters = {};
  Object.keys(this.reportConfiguration.displayFiltersData).forEach(k => {
    localDisplayFilters[k] = {
      ...this.reportConfiguration.displayFilters[k],
      ...this.reportConfiguration.displayFiltersData[k],
      ...ReportHelper.filterFunctions[k]?.settings,
    };
  });

	if (this.reportConfiguration.report.kind === 'partner') {
		delete localDisplayFilters.partner;
	}

  this.reportConfiguration.$emit('display-filters', localDisplayFilters);
}


/*
 * Filters
*/

ReportHelper.dateRanges = {
  purchaseDate: 'Purchase Date',
  redemptionDate: 'Redemption Date',
  paymentDate: 'Payment Date',
  plDate: 'P/L Date',
  profitLossDate: 'Profit/Loss Date',
  activityBookingDate: 'Activity Booking Date',
  passPurchaseDate: 'Pass Purchase Date',
}

ReportHelper.identifierTypes = {
  allIds: 'All IDs',
  orderId: 'Order ID',
  tuiOrderId: 'TUI Order ID',
  tuiActivityId: 'TUI Activity Booking ID',
}

ReportHelper.prototype.runFilter = async function (name, params = {}) {
	params['functionName'] = name;
	if (this.reportConfiguration.report.kind === 'venue') {
		return $api.reports.runVenueReport(this.reportConfiguration.report.id, this.reportConfiguration.venueId, params);
	} else {
		return $api.reports.runReport(this.reportConfiguration.report.id, params);
	}
}

ReportHelper.filterFunctions = {
  campaigns: {
    async load(params) {
        this.reportConfiguration.displayFiltersData.campaigns = {
          data: (await this.runFilter('getCampaigns', params)).data,
        }
    },
    getText(filters, displayFiltersData) {
      if (filters.campaignIds) {
        return displayFiltersData.data.filter(x => filters.campaignIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  dateRangeType: {
    load(params) {
      this.reportConfiguration.displayFiltersData.dateRangeType = {
        data: params.dateRanges.map(x => ({
          id: x,
          name: ReportHelper.dateRanges[x]
        }))
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.dateRangeType) {
        return displayFiltersData.data.filter(x => x.id === filters.dateRangeType)?.name;
      }
    }
  },
  dateRange: {
    settings: {
      type: 'dateSelector',
      range: true,
    },
    load(params) {
      this.reportConfiguration.displayFiltersData.dateRange = {}
    },
    getText(filters, displayFiltersData) {
      if (filters.startDateTime || filters.endDateTime) {
        let text = '';
        if (filters.startDateTime) {
          text += 'From ' + moment(filters.startDateTime).format('MM/DD/YYYY');
        }
        if (filters.endDateTime) {
          text += ' To ' + moment(filters.endDateTime).format('MM/DD/YYYY');
        }
        return text;
      }
    }
  },
  date: {
    load(params) {
      this.reportConfiguration.displayFiltersData.date = {}
    },
    getText(filters, displayFiltersData) {
      if (filters.date) {
        return moment(filters.date).format('MM/DD/YYYY');
      }
    }
  },
  month: {
      settings: {
          type: 'dateSelector',
          range: false,
          dateType: 'month',
      },
    load(params) {
      this.reportConfiguration.displayFiltersData.month = {}
    },
    getText(filters, displayFiltersData) {
      if (filters.month) {
        return moment(filters.month).format('MM/YYYY');
      }
    }
  },
  partner: {
    async load(params) {
      this.reportConfiguration.displayFiltersData.partner = {
		  
        data: (await this.runFilter('getPartners', params)).data
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.partnerId && displayFiltersData) {
        return displayFiltersData.data.filter(x => x.id === filters.partnerId).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
	partners: {
		async load(params) {
			this.reportConfiguration.displayFiltersData.partners = {

				data: (await this.runFilter('getPartners', params)).data
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.partnerIds && displayFiltersData) {
				return displayFiltersData.data.filter(x => filters.partnerIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
			}
		}
	},
  offers: {
    async load(params, filterOptions) {
      if (this.reportConfiguration.filters.partnerId || filterOptions?.presets) {
        if (filterOptions?.presets) {
          if(!params) params = {};
          Object.keys(filterOptions.presets).forEach(key => {
            params[key] = this.reportConfiguration.filterPresets[filterOptions.presets[key]];
          });
        }
        this.reportConfiguration.displayFiltersData.offers = {
          data: (await this.runFilter('getOffers', params)).data
        }
      } else {
        this.reportConfiguration.displayFiltersData.offers = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.offerIds) {
        const offerIds = Array.isArray(filters.offerIds) ? filters.offerIds : [filters.offerIds];
        return displayFiltersData.data.filter(x => offerIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  affiliates: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.affiliates = {
          data: (await this.runFilter('getAffiliates', params)).data
        }
      } else {
        this.reportConfiguration.displayFiltersData.affiliates = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.affiliateIds) {
        return displayFiltersData.data.filter(x => filters.affiliateIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  salesChannels: {
    load(params) {
      //TODO: when all the reports that use salesChannels are migrated, delete the duplicated options declarated in BwFilters.vue
      this.reportConfiguration.displayFiltersData.salesChannels = {
        data: [
          {id: 'sale', name: 'Direct Sale'},
          {id: 'reseller_revenue', name: 'Third Party'},
          {id: 'promo_revenue', name: 'Promotion'},
        ]
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.salesChannel) {
        return displayFiltersData.data.filter(x => x.id === filters.salesChannel)?.name;
      }
    }
  },
  regions: {
    load(params) {
      this.reportConfiguration.displayFiltersData.regions = {
        data: [
          {id: 'pacific_rockies', name: 'Pacific/Rockies'},
          {id: 'central', name: 'Central'},
          {id: 'northeast', name: 'Northeast'},
          {id: 'southeast', name: 'Southeast'},
        ]
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.regionId) {
        return displayFiltersData.data.filter(x => x.id === filters.regionId)?.name;
      }
    }
  },
	processingAccount: {
		load(params) {
			this.reportConfiguration.displayFiltersData.processingAccount = {
				data: [
					{id: 'all', name: 'All'}, 
					{id: 'bw', name: 'Bandwango Processing'},
					{id: 'partner', name: 'Partner'},
				]
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.processingAccountId) {
				return displayFiltersData.data.filter(x => x.id === filters.processingAccountId)?.name;
			}
		}
	},
	signUpSource: {
		load(params) {
			this.reportConfiguration.displayFiltersData.signUpSource = {
				data: [
					{id: 'all', name: 'All'},
					{id: 'referred', name: 'Referred'},
					{id: 'direct', name: 'Direct'},
				]
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.signUpSourceIds) {
				return displayFiltersData.data.filter(x => x.id === filters.signUpSourceIds)?.name;
			}
		}
	},
	fulfillers: {
		async load(params) {
			this.reportConfiguration.displayFiltersData.fulfillers = {

				data: (await this.runFilter('getFulfillers', params)).data
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.fulfillerId) {
				return displayFiltersData.data.filter(x => x.id === filters.fulfillerId)?.name;
			}
		}
	},
  minLocations: {
    load(params) {
      this.reportConfiguration.displayFiltersData.minLocations = {
        data: 0
      }
    },
    getText(filters, displayFiltersData) {
      return filters.minLocations || 0;
    }
  },
	minPoints: {
		load(params) {
			this.reportConfiguration.displayFiltersData.minPoints = {
				data: 0
			}
		},
		getText(filters, displayFiltersData) {
			return filters.minPoints || 0;
		}
	},
  identifierType: {
    load(params) {
      this.reportConfiguration.displayFiltersData.identifierType = {
        data: params.identifierTypes.map(x => ({
          id: x,
          name: ReportHelper.identifierTypes[x]
        }))
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.identifierType) {
        return displayFiltersData.data.filter(x => x.id === filters.identifierTypes)?.name;
      }
    }
  },
  identifier: {
		load(params) {
			this.reportConfiguration.displayFiltersData.identifier = {
				data: null
			}
		},
		getText(filters, displayFiltersData) {
			return filters.identifier;
		}
	},
	includeFreeAttributes: {
		load(params) {
			this.reportConfiguration.displayFiltersData.includeFreeAttributes = {
				data: false
			}
		},
		getText(filters, displayFiltersData) {
			return !!filters.includeFreeAttributes;
		}
	},
  resellers: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.resellers = {
          data: (await this.runFilter('getResellers', params)).data
        }
      } else {
        this.reportConfiguration.displayFiltersData.resellers = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.resellerIds) {
        return displayFiltersData.data.filter(x => filters.resellerIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  promos: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.promos = {
	        data: (await this.runFilter('getPromos', params)).data,
        }
      } else {
        this.reportConfiguration.displayFiltersData.promos = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.promoIds) {
        return displayFiltersData.data.filter(x => filters.promoIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
	promoCodes: {
		async load(params) {
			if (this.reportConfiguration.filters.partnerId && this.reportConfiguration.filters.promoIds?.length) {
				this.reportConfiguration.displayFiltersData.promoCodes = {
					data: (await this.runFilter('getPromoCodes', params)).data,
				}
			} else {
				this.reportConfiguration.displayFiltersData.promoCodes = {
					data: []
				}
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.promoCodeIds) {
				return displayFiltersData.data.filter(x => filters.promoCodeIds.includes(x.id)).map(x => `${x.code}`).join(', ');
			}
		}
	},
  venues: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.venues = {
          data: (await this.runFilter('getVenues', params)).data
        }
      } else {
        this.reportConfiguration.displayFiltersData.venues = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.venueIds) {
        return displayFiltersData.data.filter(x => filters.venueIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  products: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.products = {
          data: (await this.runFilter('getProducts', params)).data
        };
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.productIds) {
        return displayFiltersData.data.filter(x => filters.productIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  fields: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.fields = {
          data: (await this.runFilter('getFields', params)).data
        }
      } else {
        this.reportConfiguration.displayFiltersData.fields = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.fieldIds) {
        return displayFiltersData.data.filter(x => filters.fieldIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  deals: {
    settings: {
      type:'select',
      key:'dealIds',
    },
    async load(params) {
        this.reportConfiguration.displayFiltersData.deals = {
	        data: (await this.runFilter('getDeals', params)).data,
        }
    },
    getText(filters, displayFiltersData) {
      if (filters.dealIds) {
        return displayFiltersData.data.filter(x => filters.dealIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  messageLists: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.messageLists = {
          data: (await this.runFilter('getMessageLists', params)).data
        }
      } else {
        this.reportConfiguration.displayFiltersData.messageLists = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.messageListIds) {
        return displayFiltersData.data.filter(x => filters.messageListIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      }
    }
  },
  categories: {
    async load(params) {
      if (this.reportConfiguration.displayFilters.categories.data.length === 0) {
        if (this.reportConfiguration.filters.partnerId) {
          this.reportConfiguration.displayFiltersData.categories = {
            data: (await this.runFilter('getCategories', params)).data
          }
        } else {
          this.reportConfiguration.displayFiltersData.categories = {
            data: []
          }
        }
      } else {
        this.reportConfiguration.displayFiltersData.categories = {
          data: this.reportConfiguration.displayFilters.categories.data
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.categoryIds) {
        return displayFiltersData.data.filter(x => filters.categoryIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      } else {
        this.reportConfiguration.displayFiltersData.categoryIds = {
          data: []
        }
      }
    }
  },
  items: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        const results = (await Promise.all([
	        this.runFilter('getPackages', params),
	        this.runFilter('getDeals', params),
	        this.runFilter('getProducts', params),
        ])).map(x => x.data);
        this.reportConfiguration.displayFiltersData.items = {
          packages: results[0],
          deals: results[1],
          products: results[2]
        }
      } else {
        this.reportConfiguration.displayFiltersData.items = {
          packages: [],
          deals: [],
          products: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      let results = [];
      if (filters.packageIds) {
        results.push(displayFiltersData.packages.filter(x => filters.packageIds.includes(x.id)).map(x => `${x.name} (${x.id})`));
      }
      if (filters.dealIds) {
        results.push(displayFiltersData.deals.filter(x => filters.dealIds.includes(x.id)).map(x => `${x.name} (${x.id})`));
      }
      if (filters.productIds) {
        results.push(displayFiltersData.products.filter(x => filters.productIds.includes(x.id)).map(x => `${x.name} (${x.id})`));
      }
      return results.join(', ');
    }
  },
  statuses: {
    async load(params) {
      if (this.reportConfiguration.filters.partnerId) {
        this.reportConfiguration.displayFiltersData.statuses = {
          data: (await this.runFilter('getStatuses', params)).data
        }
      } else {
        this.reportConfiguration.displayFiltersData.statuses = {
          data: []
        }
      }
    },
    getText(filters, displayFiltersData) {
      if (filters.statusIds) {
        return displayFiltersData.data.filter(x => filters.statusIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
      } 
    }
  },
  users: {
    async load(params) {
	    let functionName = 'getUsers';
	    if (params['managers']) {
		    functionName = 'getManagers';
	    } else if (params['callCenterAgents']) {
		    functionName = 'getCallCenterAgents';
	    }
			      
      this.reportConfiguration.displayFiltersData.users = {
          data: (await this.runFilter(functionName, params)).data
        }
    },
    getText(filters, displayFiltersData) {
      if (filters.userIds) {
	      if(Array.isArray(filters.userIds)) {
		      return displayFiltersData.data.filter(x => filters.userIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
	      } else {
					return displayFiltersData.data.filter(x => x.id === filters.userIds).map(x => `${x.name} (${x.id})`).join(', ');
	      }
      } 
    }
  },
	polls: {
		async load(params) {
			if (this.reportConfiguration.filters.partnerId) {
				this.reportConfiguration.displayFiltersData.polls = {
					data: (await this.runFilter('getPolls', params)).data
				}
			} else {
				this.reportConfiguration.displayFiltersData.polls = {
					data: []
				}
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.pollId) {
				return displayFiltersData.data.filter(x => x.id === filters.pollId)?.name;
			}
		}
	},
  hideDoNotCharge: {
    load(params) {
      this.reportConfiguration.displayFiltersData.hideDoNotCharge = {
        data: false
      }
    },
    getText(filters, displayFiltersData) {
      return filters.hideDoNotCharge ? 'Yes' : 'No';
    }
  },
	inactive: {
		load(params) {
			this.reportConfiguration.displayFiltersData.inactive = {
				data: false
			}
		},
		getText(filters, displayFiltersData) {
			return filters.inactive ? 'Inactive' : 'Active';
		}
	},
	duration: {
		async load(params) {
			this.reportConfiguration.displayFiltersData.durations = {
				data: (await this.runFilter('getDurations', params)).data
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.durationId) {
				return displayFiltersData.data.filter(x => x.id === filters.durationId)?.name;
			}
		}
	},
	outcomes: {
		async load(params) {
			this.reportConfiguration.displayFiltersData.outcomes = {
				data: (await this.runFilter('getOutcomes', params)).data
			}
		},
		getText(filters, displayFiltersData) {
			if (filters.resellerIds) {
				return displayFiltersData.data.filter(x => filters.resellerIds.includes(x.id)).map(x => `${x.name} (${x.id})`).join(', ');
			}
		}
	},
}
 
/*
 * Helper functions
 */

ReportHelper.watchObject = {
  success_msg: function (msg) {
    this.reportHelper.watchSuccessMessage(msg);
  },
  error_msg: function (msg) {
    this.reportHelper.watchErrorMessage(msg);
  },
  parentFilters: {
    deep: true,
    handler(val) {
      this.reportHelper.watchParentFilterHandler(val);
    }
  },
}

ReportHelper.propsObject = {
  report: {
    type: Object,
    required: true,
  },
  partnerId: {
    type: Number,
    required: true
  },
  parentFilters: {
    type: Object,
    required: false
  },
  filterPresets: {
    type: Object,
    required: false
  },
	initialLoad: {
	  	type: Boolean,
		required: true,
	},
  venueId: {
    type: Number,
    required: false
  }
}

ReportHelper.formatData = function (data) {
  Object.assign(data, {
    reportHelper: {},
    partner: {},
    success_msg: '',
    error_msg: '',
    displayFiltersData: {},
    fireGetData: true,
    getPermissions: data.getPermissions,
    permissions: [],
  });
  for (let subreport in data.subreports) {
    Object.assign(data.subreports[subreport], {
      loading: true,
      exportData: {
        loading: false
      },
    });
    data.subreports[subreport].tableData.response = {};
  }
		
  return data;
}


export default ReportHelper;
